<template>
  <el-card
    class="detail"
    v-loading="!isLoadForm"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <SiruiSearch
      ref="receivablesStatementListSearch"
      :query="query"
      :columns="searchFormColumns"
      @changeCompanyHandler="changeCompanyHandler"
      @changeDepartmentHandler="changeDepartmentHandler"
      @resetBtnClick="resetBtnClickHandler"
      @searchBtnClick="queryBtnClickHandler"
    ></SiruiSearch>
    <div class="main-content">
      <SiruiTable
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="true"
        :footerMethod="footerMethod"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @dblclickEvent="dblclickEvent"
      >
        <!-- 0512 客户名称常驻原因，去掉序号显示 -->
        <!-- <vxe-table-column
          type="seq"
          width="50"
          title="序号"
          v-if="columnList.length"
        ></vxe-table-column> -->
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'settlementBusinessType'">{{
              businessCategory?.find((item) => item.value == row['settlementBusinessType'])?.label
            }}</template>
            <template v-else-if="item.field === 'settlementStatus'">{{
              settlementStatus?.find((item) => item.value == row['settlementStatus'])?.label
            }}</template>
            <template v-else-if="item.field === 'settlementType'">
              {{ row.settlementType == '1' ? '预结算' : '终结算' }}
            </template>
            <template v-else-if="item.field === 'storageCreateTime'">
              {{ dateCompare(row.lastCollectedDate, row.settlementDate) }}
            </template>
            <template v-else-if="item.field === 'settlementIssueStatus'">{{
              settlementIssueStatus?.find((item) => item.value == row['settlementIssueStatus'])
                ?.label
            }}</template>
            <template v-else-if="item.field === 'receiveStatus'">{{
              settlementReceiveStatus?.find((item) => item.value == row['receiveStatus'])?.label
            }}</template>
            <template v-else-if="item.field === 'unpaidAmount'">{{
              userInfo.businessGroup == '物贸'
                ? $utils.commafy(
                    $utils.toNumber(
                      replaceZeroStr((row.originalTotalAmount - row.collectedAmount).toFixed(2))
                    ),
                    { digits: 2 }
                  )
                : replaceZeroStr((row.originalTotalAmount - row.collectedAmount).toFixed(2))
            }}</template>
            <template v-else-if="item.field === 'printFlag'">
              {{ row.printFlag == 0 ? '未打印' : '已打印' }}
            </template>
            <template v-else-if="item.field === 'pushJinDieFlag'">
              {{ row.pushJinDieFlag == 0 ? '失败' : row.pushJinDieFlag == 1 ? '成功' : '' }}
            </template>
            <template v-else-if="item.field === 'payunit'">
              {{
                row.payunitCode && userInfo.businessGroup == '物贸'
                  ? dictListMap.basic_unit?.find((item) => item.value == row['payunitCode'])?.label
                  : row.payunit
              }}
            </template>
            <!-- 物贸板块使用千分位显示金额 -->
            <template
              v-else-if="
                [
                  'originalTotalAmount',
                  'domesticTotalAmount',
                  'invoiceAmount',
                  'collectedAmount',
                ].includes(item.field) && userInfo.businessGroup == '物贸'
              "
            >
              {{ $utils.commafy($utils.toNumber(row[item.field]), { digits: 2 }) }}
            </template>
            <template v-else-if="item.field == 'oaUrl'">
              <a
                href="javascript:void(0);"
                v-if="row[item.field]"
                @click="goOaLink(row[item.field])"
                >查看</a
              >
            </template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </SiruiTable>
      <!-- <PrintFile :printIdList="['10952']" /> -->
    </div>
    <!-- 打印弹框 -->
    <Print ref="easyPrint">
      <PrintFile :printIdList="printIdList" v-if="printIdList.length" />
      <!-- <print-demo content="你好"></print-demo> -->
    </Print>

    <PrintDialog ref="PrintDialog" @printHandler="DetailprintHandler"></PrintDialog>
    <AddDialog ref="AddDialog" @chooseBusinessHandler="chooseBusinessHandler"></AddDialog>
    <ApprovalDialog ref="approvalDialogRef" @approvalSuccess="approvalSuccess"></ApprovalDialog>
    <!-- 批量开票前的弹窗 -->
    <InvoiceDialog
      ref="invoiceDialogRef"
      :extraOptions="extraOptions"
      @chooseInvoiceHandler="chooseInvoiceHandler"
    ></InvoiceDialog>
  </el-card>
</template>

<script>
  import { mapState } from 'vuex';
  import { searchColumns, defaultTableColumn } from './index.js';
  // , defaultMenuBtnList
  import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import { filterEmpty } from '@/common/js/util';
  import Print from '@/components/Print';
  // import PrintDemo from '@/components/Print/printDemo.vue';
  import PrintDialog from '../../components/PrintDialog.vue';
  import AddDialog from './components/AddDialog.vue';
  import ApprovalDialog from './components/approvalDialog';
  import PrintFile from './components/PrintFile.vue';
  import statementListMixin from './index.js';
  import InvoiceDialog from './components/InvoiceDialog.vue';
  import { fmoney } from '@/common/js/util';

  export default {
    mixins: [statementListMixin],
    name: 'receivablesList',
    data() {
      return {
        tableData: [],
        query: {
          settlementCompanyNo: '',
          settlementDepartmentNo: '',
          customerNo: '',
          customerList: null,
          salesmanNo: '',
          salesmanList: null,
          settlementDateStart: '',
          settlementDateEnd: '',
          originalTotalAmountStart: '',
          originalTotalAmountEnd: '',
          projectInitiationNoLike: '',
          contractNoLike: '',
          receivableSettlementNoLike: '',
          settlementStatus: '',
          settlementIssueStatus: '',
          receiveStatus: '',
          settlementType: '',
          printFlag: '',
          settlementBusinessType: '',
          requestDepartmentNameLike: '',
        },
        hasExtraOptions: false,
        companyCode: null,
        storageName: '',
        isLoadForm: true,
        tableTotal: 0,
        multipleSelection: [],
        content: '',
        loading: false,
        id: null, //打印id
        publicPath: '',
        publicName: '',
        publicTitle: '应收结算单',
        menuButtonList: [], // 表格功能按钮
        columnList: [],
        printIdList: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      extraOptions() {
        return this.hasExtraOptions
          ? [
              {
                value: '1',
                label: '数字化电子专票',
              },
              {
                value: '2',
                label: '数字化电子普票发票',
              },
            ]
          : [];
      },
      storageCreatePersonName() {
        return this.userInfo.personName;
      },
      searchFormColumns() {
        return searchColumns(this);
      },
      businessCategory() {
        return this.dictListMap?.businessCategory;
      },
      settlementStatus() {
        return this.dictListMap?.settlementStatus;
      },
      settlementIssueStatus() {
        return this.dictListMap?.settlementIssueStatus;
      },
      settlementReceiveStatus() {
        return this.dictListMap?.settlementReceiveStatus;
      },
    },
    mounted() {
      // this.getTableData();
      this.getButtonList();
    },
    methods: {
      // 底部合计
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['settlementQuantitySum'].includes(column.property)) {
              return fmoney(
                this.replaceZeroStr(
                  data
                    .reduce((cur, next) => cur + +next.settlementQuantitySum, 0)
                    .toFixed(this.isWuMaoAccount ? 8 : 2)
                ),
                this.isWuMaoAccount ? 8 : 2
              );
            } else if (['originalTotalAmount'].includes(column.property)) {
              return fmoney(
                this.replaceZeroStr(
                  data.reduce((cur, next) => cur + +next.originalTotalAmount, 0).toFixed(2)
                )
              );
            } else if (['domesticTotalAmount'].includes(column.property)) {
              return fmoney(
                this.replaceZeroStr(
                  data.reduce((cur, next) => cur + +next.domesticTotalAmount, 0).toFixed(2)
                )
              );
            }
            return null;
          }),
        ];
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          // TODO 后端还没处理好返回数据，前端先这样处理
          // this.menuButtonList = e.length > 0 ? e : defaultMenuBtnList;
          this.menuButtonList = e.length > 0 ? e : [];
          console.log(e, '查看按钮列表');
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(defaultTableColumn(this)).then(() => {
          // console.log(11111);
          this.columnList = defaultTableColumn(this);
        });
      },
      chooseClick(type) {
        console.log(type, '点击按钮操作');
        if (type == 'add') {
          this.addNewSettleAccountsHandler();
        } else if (type == 'edit') {
          this.editSettleAccountsHandler();
        } else if (type == 'delete') {
          this.deleteBtnClickHandler();
        } else if (type == 'export') {
          this.exportSettleAccountsHandler();
        } else if (type == 'exportProperty') {
          this.exportPorperty();
        } else if (type == 'close') {
          this.closeSettleAccountsHandler();
        } else if (type == 'lock') {
          this.lockSettleAccountsHandler();
        } else if (type == 'print') {
          this.printBtnClickHandler();
        } else if (type == 'pushJindie') {
          this.pushJindieBtnClickHandler();
        } else if (type == 'approval') {
          this.approval();
        } else if (type == 'withdraw') {
          this.withdraw();
        } else if (type == 'batchInvoice') {
          this.batchInvoice();
        } else if (type == 'withdrawApprovalHandler') {
          if (!this.multipleSelection.length) {
            this.$message.error('请选择行');
            return false;
          }
          if (this.multipleSelection.some((item) => item.settlementStatus != '02')) {
            this.$message.error('只有审批中才可以撤回审批');
            return;
          }
          // this.loading.startLoading();
          this.loading = true;
          this.$axios
            .post('/financial/receivableSettlement/withdrawOA', {
              businessGroup: this.userInfo.businessGroup,
              ids: this.multipleSelection.map((item) => item.id),
              oaId: this.userInfo.oaId,
            })
            .then((res) => {
              console.log(res);
              // this.loading.endLoading();
              this.loading = false;
              const { code, msg } = res.data;
              if (code == 0) {
                this.$message.success('撤回成功');
                this.queryBtnClickHandler();
              } else {
                this.$message.error(msg);
              }
            })
            .catch(() => {
              // this.loading.endLoading();
              this.loading = false;
            });
        }
      },
      approval() {
        const selectedList = this.multipleSelection;
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const selectList = selectedList.filter((item) => {
          return !['04', '03'].includes(item.settlementBusinessType);
        });
        if (selectList.length > 0) {
          this.$message.warning('请选择正确的数据！');
          return;
        }
        console.log(selectedList);
        const approvalList = selectedList.filter((item) => {
          return !['02'].includes(item.settlementStatus);
        });
        if (approvalList.length > 0) {
          this.$message.warning('请选择审批中的数据进行操作！');
          return;
        }
        const postData = [];
        selectedList.map((item) => {
          postData.push(item.receivableSettlementNo);
        });
        console.log('postData', postData);
        this.$refs.approvalDialogRef.openDialog({ ids: postData });
      },
      approvalSuccess() {
        this.queryBtnClickHandler();
      },

      // 撤回
      withdraw() {
        const selectedList = this.multipleSelection;
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const selectList = selectedList.filter((item) => {
          return !['04', '03'].includes(item.settlementBusinessType);
        });
        if (selectList.length > 0) {
          this.$message.warning('请选择正确的数据！');
          return;
        }
        const deleteList = selectedList.filter((item) => {
          return !['02'].includes(item.settlementStatus);
        });
        if (deleteList.length > 0) {
          this.$message.warning('请选择审批中的数据进行操作！');
          return;
        }
        this.$confirm('确定要撤回吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const postData = [];
            selectedList.map((item) => {
              postData.push(+item.id);
            });
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLE_WITHDRAW_API, {
              ids: postData,
              oaId: this.userInfo.oaId,
              businessGroup: '园区',
            });
            if (data.code === 0) {
              this.$message.success('撤回成功');
              this.queryBtnClickHandler();
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      // 批量开票
      async batchInvoice() {
        const selectedList = this.multipleSelection;
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        const deleteList = selectedList.filter((item) => {
          return !['02'].includes(item.settlementIssueStatus);
        });
        if (deleteList.length > 0) {
          this.$message.warning('请选择未开票的数据进行操作！');
          return;
        }
        // 园区需要多显示两种开票类型
        this.hasExtraOptions = selectedList.every((v) => v.settlementBusinessType === '04');
        this.$nextTick(() => {
          // 打开弹窗
          this.$refs.invoiceDialogRef.openDialog();
        });

        // const postData = selectedList.map((item) => item.id - 0);
        // const { data } = await this.$axios.post(
        //   RECEIVABLES_TRADE.RECEIVABLE_BATCH_INVOICE,
        //   postData
        // );
        // if (data.code === 0) {
        //   this.$message.success('开票成功');
        //   this.queryBtnClickHandler();
        // } else {
        //   this.$message.error(`${data.msg}`);
        // }
      },
      // 进行开票
      async invoice(specialOrOrdinary) {
        let receivableSettlementIdList = this.multipleSelection.map((item) => item.id - 0);
        const postData = {
          receivableSettlementIdList,
          specialOrOrdinary,
        };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.RECEIVABLE_BATCH_INVOICE,
          postData
        );
        if (data.code === 0) {
          this.$message.success('开票成功');
          this.queryBtnClickHandler();
        } else {
          this.$message.error(`${data.msg}`);
        }
      },

      // 获取开票前弹窗值
      chooseInvoiceHandler(value) {
        console.log('选择的值', value);
        // 1是普通发票，0是专用发票
        this.invoice(Number(value));
        // if (value == '1') {
        //   this.invoice(1);
        // } else if (value == '0') {
        //   this.invoice(0);
        // } else if (value == '2') {
        //   this.invoice(2);
        // }
      },
      //是否逾期
      dateCompare(date1, date2) {
        if (date1 && date2) {
          date1 = date1.replace(/\-/gi, '/');
          date2 = date2.replace(/\-/gi, '/');
          let time1 = new Date(date1).getTime();
          let time2 = new Date(date2).getTime();
          if (time1 > time2) {
            return '是';
          } else {
            return '否';
          }
        }
      },
      // // 切换公司
      // changeCompanyHandler(val, partnerZhName1) {
      //   console.log(val, '切换公司', partnerZhName1);
      //   this.companyCode = val.val;
      //   this.query.settlementDepartmentNo = null;
      // },
      // 切换供应商
      changeCustomerNoMethod(val) {
        console.log(val, '修改供应商');
        this.query.customerNo = val[0].partnerCode;
      },

      //修改业务员
      changeSalesmanNoMethod(val) {
        this.query.salesmanNo = val[0].personNo;
        console.log(val, '修改业务员');
      },
      // 搜索
      async queryBtnClickHandler() {
        // console.log('搜索', this.query);
        // console.log('搜索', this.query);
        console.log(this.query, '搜索');
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.getTableData();
      },
      //处理查询数据
      getQueryData() {
        const query = Object.assign({}, this.$refs.receivablesStatementListSearch.query);
        query.printFlag = query.printFlag === '0' ? 0 : query.printFlag === '1' ? 1 : '';
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        return filterEmpty(query);
      },
      // 修改合同
      changeContractMethod(val) {
        this.query.contractNo = val[0].contractNo;
        console.log(val, '修改合同');
      },
      // 分页操作
      changePageHandler(pageNum, pageSize) {
        this.getTableData(pageNum, pageSize);
      },
      handleMultiple2Single(multipleSelection, id) {
        let selectList = multipleSelection ? multipleSelection : [];
        if (selectList.length > 0) {
          return selectList[0][id];
        }
        return null;
      },
      // 重置
      resetBtnClickHandler() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.multipleSelection = [];
        this.$refs.siruiTable.clearCheckboxReserve();
        if (this.userInfo.companyCode != 'OAC19') {
          this.query = {
            ...this.query,
            // settlementCompanyNo: this.userInfo.companyCode,
            // settlementDepartmentNo: this.userInfo?.departmentCode,
          };
          this._getDepartmentByCompanyCodeApi(this.userInfo.companyCode);
        }
        // setTimeout(() => {
        //   this.$refs.IPagination.handleSizeChange(this.$refs.IPagination.page.pageSize);
        // }, 50);
        setTimeout(() => {
          this.getTableData();
        }, 50);
      },
      // 获取表格数据
      async getTableData() {
        this.loading = true;
        const postData = this.getQueryData();
        const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_QUERY, {
          ...postData,
          businessGroup: this.userInfo.businessGroup,
        });
        console.log(data, '搜索结果');
        this.loading = false;
        if (data.code === 0) {
          this.multipleSelection = []; //初始化选中数据
          this.tableData = data.data.records;
          this.tableData.forEach((item) => {
            item.receivableAccountPeriod = item.receivableAccountPeriod
              ? item.receivableAccountPeriod.slice(0, 7)
              : '';
            item.invoiceAmount = item.invoiceAmount || 0;
            item.collectedAmount = item.collectedAmount || 0;
          });
          this.$refs.siruiTable.setPageTotal(data.data.total);
        }
      },

      // 新增按钮
      addNewSettleAccountsHandler() {
        if (this.userInfo.businessGroup == '物贸') {
          this.chooseBusinessHandler('贸易');
        } else {
          this.$refs.AddDialog.openDialog();
        }
      },
      chooseBusinessHandler(val) {
        console.log(val, '新增val');

        if (val == '贸易') {
          this.publicName = this.publicPath = 'tradeReceivablesDetail';
        } else if (val == '多式联运') {
          this.publicName = this.publicPath = 'multimodalTransportReceivablesDetail';
        } else if (val == '园区仓储') {
          this.publicName = this.publicPath = 'parkWarehouseReceivablesDetail';
        } else if (val == '监管单') {
          this.publicName = this.publicPath = 'superviseContractDetail';
        } else if (val == '园区物业') {
          this.publicName = this.publicPath = 'parkPropertyReceivablesCreate';
        } else if (val == '城矿') {
          this.publicName = this.publicPath = 'tradeReceivablesDetailCK';
        }
        this.publicTitle = `${val}应收结算单`;
        let path = {
          path: `/receivablesAndPayables/${this.publicPath}`,
          name: `${this.publicName}`,
          meta: {
            keepAlive: true,
            title: `${this.publicTitle}`,
          },
          query: {
            status: 'create',
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 编辑
      editSettleAccountsHandler() {
        const selectedList = this.multipleSelection;
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        if (selectedList.length > 1) {
          this.$message.error('只能选择一行编辑');
          return;
        }
        const editList = selectedList.filter((item) => {
          return ['02', '04', '06', '07'].includes(item.settlementStatus);
        });
        console.log(editList, '编辑');
        if (editList.length > 0) {
          this.$message.error('选中的包括了不能编辑的数据');
          return;
        }
        console.log(selectedList, 'selectedList');

        if (!['01', '02', '04', '05'].includes(selectedList[0].settlementBusinessType)) {
          this.$message.error('其他业务板块正在开发中！');
          return;
        } else {
          this.judgeBusinessType(selectedList[0]);
        }

        let path = {
          path: `/receivablesAndPayables/${this.publicPath}`,
          name: `${this.publicName}`,
          meta: {
            keepAlive: true,
            title: `${this.publicTitle}`,
          },
          query: {
            status: 'edit',
            id: selectedList[0].id,
            receiveNo: selectedList[0].receivableSettlementNo,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 导出
      async exportSettleAccountsHandler() {
        const selectedList = this.multipleSelection;
        if (selectedList.length > 0) {
          const postData = [];
          selectedList.map((item) => {
            postData.push(+item.id);
          });
          const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_EXPORT, {
            ids: postData,
          });
          if (data.code === 0) {
            window.location.href = data.data;
            this.$message.success('导出成功');
          } else if (data.code === 5000) {
            this.$message.error(`${data.msg}`);
          } else {
            this.$message.error(`${data.msg}`);
          }
        } else {
          const postData = this.query;
          const { data } = await this.$axios.post(
            RECEIVABLES_TRADE.RECEIVABLESLIST_EXPORT,
            postData
          );
          if (data.code === 0) {
            window.location.href = data.data;
            this.$message.success('导出成功');
          } else {
            this.$message.error(`${data.msg}`);
          }
        }
      },
      // 第三方导出模板
      async exportPorperty() {
        const selectedList = this.multipleSelection;
        if (selectedList.length > 0) {
          const postData = [];
          let index = selectedList.findIndex((item) => item.settlementBusinessType != '04');
          if (index != -1) {
            this.$message.warning('请选择正确的数据！');
          }
          selectedList.map((item) => {
            postData.push(+item.id);
          });
          const { data } = await this.$axios.post(RECEIVABLES_TRADE.PAYABLELIST_EXPORT_PORPERTY, {
            ids: postData,
          });
          if (data.code === 0) {
            window.location.href = data.data;
            this.$message.success('导出成功');
          } else {
            this.$message.error(`${data.msg}`);
          }
        } else {
          this.$message.warning('请至少选择一条数据！');
        }
      },
      //删除
      async deleteBtnClickHandler() {
        const selectedList = this.multipleSelection;
        console.log(selectedList, 'selectedList');
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        console.log(selectedList);
        const deleteList = selectedList.filter((item) => {
          return ['02', '04', '06', '07'].includes(item.settlementStatus);
        });

        console.log(deleteList, '删除');
        if (deleteList.length > 0) {
          this.$message.error('选中的包括了不能删除的数据');
          return;
        }
        this.$confirm('确定要删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const postData = [];
            selectedList.map((item) => {
              postData.push(+item.id);
            });
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_DELETE, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('删除成功');
              this.queryBtnClickHandler();
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      //关闭
      async closeSettleAccountsHandler() {
        const selectedList = this.multipleSelection;
        console.log(selectedList, 'selectedList');
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        console.log(selectedList);
        const receiveList = selectedList.filter((item) => {
          return ['02', '03'].includes(item.receiveStatus);
        });
        const settlementIssueList = selectedList.filter((item) => {
          return ['02', '03'].includes(item.settlementIssueStatus);
        });
        console.log(receiveList, '关闭');
        if (receiveList.length > 0 || settlementIssueList.length > 0) {
          this.$message.error('选中的包括了不能关闭的数据');
          return;
        }
        this.$confirm('确定要关闭吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const postData = [];
            selectedList.map((item) => {
              postData.push(+item.id);
            });
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_CLOSE, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('关闭成功');
              this.queryBtnClickHandler();
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      async pushJindieBtnClickHandler() {
        const selectedList = this.multipleSelection;
        console.log(selectedList, 'selectedList');
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        console.log(selectedList);
        const receiveList = selectedList.filter((item) => {
          return ['04'].includes(item.settlementStatus);
        });

        const pushJinDieFlagList = selectedList.filter((item) => {
          return [1].includes(item.pushJinDieFlag);
        });
        console.log(receiveList, '关闭');
        if (receiveList.length < 1 && pushJinDieFlagList.length > 0) {
          this.$message.error('只有已通过且未推送成功的数据才能推送到金蝶');
          return;
        }
        this.$confirm('确定要推送到金蝶吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const postData = [];
            selectedList.map((item) => {
              postData.push(+item.id);
            });
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLE_PUSHJINDIE_API, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('推送成功');
              this.queryBtnClickHandler();
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },

      //锁定
      async lockSettleAccountsHandler() {
        const selectedList = this.multipleSelection;
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }
        console.log(selectedList);
        const lockList = selectedList.filter((item) => {
          return ['01', '02', '03', '05', '06', '07'].includes(item.settlementStatus);
        });

        console.log(lockList, '锁定');
        if (lockList.length > 0) {
          this.$message.error('选中的包括了不能锁定的数据');
          return;
        }
        this.$confirm('确定要锁定吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const postData = [];
            selectedList.map((item) => {
              postData.push(+item.id);
            });
            const { data } = await this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_LOCK, {
              ids: postData,
            });
            if (data.code === 0) {
              this.$message.success('锁定成功');
              this.queryBtnClickHandler();
            } else if (data.code === 10000) {
              this.$message.error(`${data.msg}`);
            } else {
              this.$message.error(`${data.msg}`);
            }
          })
          .catch(() => {});
      },
      //打印
      printBtnClickHandler() {
        const selectedList = this.multipleSelection;
        if (!selectedList.length) {
          this.$message.error('请选择行操作');
          return;
        }

        // if (selectedList.length > 1) {
        //   this.$message.error('只能选择一行打印');
        //   return;
        // }
        let settlementStatusList = selectedList.filter((item) =>
          ['04'].includes(item.settlementStatus)
        );

        if (settlementStatusList.length != selectedList.length) {
          this.$message.error('只有已通过的结算单才能进行打印');
          return;
        }
        this.printIdList = selectedList.map((item) => item.id);
        const selectedListSettlementBusinessType = [
          ...new Set(selectedList.map((item) => item.settlementBusinessType)),
        ];
        if (selectedListSettlementBusinessType.length > 1) {
          this.$message.error('只能选择同种类型打印');
          return;
        }
        // 园区仓储的采用新方式打印
        if (selectedListSettlementBusinessType[0] == '03') {
          // 使用第三方打印
          setTimeout(() => {
            this.$refs.easyPrint.print();
            // 清空
            this.printIdList = [];
            this.multipleSelection = [];
            this.$refs.siruiTable.clearCheckboxReserve();
          }, 500);
        } else {
          this.$refs.PrintDialog.openDialog();
          this.printIdList = selectedList.map((item) => item.id);
        }

        // this.loading.startLoading();
      },
      DetailprintHandler(printType) {
        // this.loading.startLoading();
        this.printIdList.forEach((id) => {
          const params = {
            id: id,
            downloadOrPrint: 'print',
          };
          this.$axios.post(RECEIVABLES_TRADE.RECEIVABLESLIST_PRINT, params).then((res) => {
            if (res.data.code === 0) {
              // this.loading.endLoading();
              if (printType == 'pdf') {
                window.open(res.data.data.pdf, '_blank');
              }
              if (printType == 'excel') {
                window.open(res.data.data.word, '_blank');
              }
            }
          });
        });
      },
      // // 表格中选择
      // handleSelectionChange(ev) {
      //   this.multipleSelection = ev.selection;
      //   console.log(this.multipleSelection, 'this.multipleSelection');
      // },
      // 表格选择行
      handleSelectionChange(row) {
        console.log(row);
        this.multipleSelection = row;
      },
      // 双击行
      dblclickEvent({ row }) {
        console.log(row, 'row');

        if (!['01', '02', '03', '04', '05', '06'].includes(row.settlementBusinessType)) {
          this.$message.error('其他业务板块正在开发中！');
          return;
        } else {
          this.judgeBusinessType(row);
        }
        let path = {
          path: `/receivablesAndPayables/${this.publicPath}`,
          name: `${this.publicName}`,
          meta: {
            keepAlive: true,
            title: `${this.publicTitle}`,
          },
          query: {
            status: 'detail',
            id: row.id,
            receiveNo: row.receivableSettlementNo,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      judgeBusinessType(row) {
        if (['01'].includes(row.settlementBusinessType)) {
          this.publicName = this.publicPath = 'tradeReceivablesDetail';
          this.publicTitle = '贸易应收结算单';
        }
        if (['02'].includes(row.settlementBusinessType)) {
          this.publicName = this.publicPath = 'multimodalTransportReceivablesDetail';
          this.publicTitle = '多式联运应收结算单';
        }
        if (['03'].includes(row.settlementBusinessType)) {
          this.publicName = this.publicPath = 'parkWarehouseReceivablesDetail';
          this.publicTitle = '园区仓储应收结算单';
        }
        if (['04'].includes(row.settlementBusinessType)) {
          this.publicName = this.publicPath = 'parkPropertyReceivablesDetail';
          this.publicTitle = '园区物业应收结算单';
        }
        if (['05'].includes(row.settlementBusinessType)) {
          this.publicName = this.publicPath = 'superviseContractDetail';
          this.publicTitle = '监管单应收结算费用清单';
        }
        if (['06'].includes(row.settlementBusinessType)) {
          this.publicName = this.publicPath = 'tradeReceivablesDetailCK';
          this.publicTitle = '城矿应收结算单';
        }
      },
    },
    components: {
      Print,
      PrintDialog,
      AddDialog,
      ApprovalDialog,
      // PrintDemo,
      PrintFile,
      InvoiceDialog,
    },
    watch: {
      $route() {
        this.getTableData();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .detail {
    background: #fff;
    border-radius: 8px;
    .foot-btn-group {
      margin-top: 30px;
    }
  }
  ::v-deep {
    .vxe-toolbar {
      margin-top: 15px;
    }
  }
</style>
